import React, { useContext } from 'react';
import { Button, AuthContext } from '../../../shared';
import { roles } from '../../../utils';
import styles from '../../Main.module.scss';
import PropTypes from 'prop-types';

const AllApps = ({ userRoles }) => {
    const { logout } = useContext(AuthContext);

    // shows all apps if the user is an admin
    if (userRoles.includes(roles.admin.name)) {
        userRoles = [roles.beekeeper.name, roles.farmer.name, roles.admin_v2.name, roles.beemover.name];
    }

    const handleRedirect = (url) => (window.location.href = url);

    return (
        <>
            <div className={styles.buttons_container}>
                {userRoles?.map((role) => (
                    <Button
                        key={roles[role].name}
                        wide
                        color={roles[role].color}
                        onClick={() => handleRedirect(roles[role].url)}
                    >
                        {roles[role].app_name}
                    </Button>
                ))}
            </div>
            <div className={styles.logoutButton} onClick={logout}>
                logout
            </div>
        </>
    );
};

AllApps.propTypes = {
    userRoles: PropTypes.array
};

export default AllApps;
